module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.isButton ? 'a' : 'label', {
    tag: "a",
    class: [_vm.isButton ? 'btn btn-' + _vm.typeColor : 'open checkbox ' + _vm.typeColor, {
      active: _vm.checked,
      disabled: _vm.disabled,
      readonly: _vm.readonly
    }],
    on: {
      "click": _vm.toggle
    }
  }, [(_vm.name) ? _c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.name
    },
    domProps: {
      "value": _vm.checked ? _vm.trueValue : _vm.falseValue
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isButton) ? _c('span', {
    staticClass: "icon dropdown-toggle",
    class: [_vm.checked ? 'btn-' + _vm.typeColor : '', {
      bg: _vm.typeColor === 'default'
    }]
  }) : _vm._e(), _vm._v(" "), (!_vm.isButton && _vm.checked && _vm.typeColor === 'default') ? _c('span', {
    staticClass: "icon"
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3c951576", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c951576!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Checkbox.vue
// module id = 19
// module chunks = 0